import { FooterConfig } from '@tenants/types/tenant';
import {
  getRootDomainUrl,
  getRootDomainUrlWithPath,
  getSubDomainUrl,
  RootDomain,
} from 'constants/domains';

export function createFooterConfig(rootDomain: RootDomain): FooterConfig {
  const footerConfig = {
    footerColumns: {
      column1: [
        {
          label: 'Explore eXp',
          link: getRootDomainUrl(rootDomain),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: 'Find an Agent',
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: 'Join eXp',
          link: getSubDomainUrl(rootDomain, 'join'),
          isAnchor: true,
          target: '_blank',
        },
        {
          label: 'Investor Relations',
          link: 'https://expworldholdings.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Company Careers',
          link: 'https://expworldholdings.com/careers/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Home Guides',
          link: getRootDomainUrlWithPath(rootDomain, '/guides'),
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: 'eXp Life',
          link: getSubDomainUrl(rootDomain, 'life'),
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Zoocasa',
          link: 'https://zoocasa.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'SUCCESS',
          link: 'https://www.success.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'eXp Revenos',
          link: 'https://revenos.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'eXp Commercial',
          link: 'https://expcommercial.com/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'eXp Luxury',
          link: 'https://expluxury.com/?tl=en',
          isAnchor: false,
          target: 'blank',
        },
      ],
      column3: [
        {
          label: 'Terms and Conditions',
          link: 'https://expworldholdings.com/terms-of-service/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Privacy Rights Request',
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Privacy Policy',
          link: 'https://expworldholdings.com/privacy-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Cookie Policy',
          link: 'https://expworldholdings.com/cookie-policy/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Brand Guidelines',
          link: 'https://join.exprealty.com/brand/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Help',
          link: 'https://searchhelp.exprealty.com/hc/en-us/',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: 'Sitemap',
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: '© 2024 eXp Realty. eXp World Holdings, Inc. All Rights Reserved.',
          },
        ],
        [
          {
            label: ' ',
          },
        ],
        [
          {
            label: 'DMCA Notice',
            link: '/dmca',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: 'This site is protected by reCAPTCHA and the Google ',
          },
          {
            label: 'Privacy Policy',
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: ' and ',
          },
          {
            label: 'Terms of Service ',
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: 'apply.',
          },
        ],
        [
          {
            label: 'Fair Housing and Reasonable Accommodations',
            link: '/fair-housing-and-reasonable-accommodations',
            target: '_blank',
            isAnchor: true,
          },
        ],
        [
          {
            label: 'MLS Compliance Statements',
          },
        ],
        [
          {
            label: 'Karen Richards – Designated Managing Broker, Broker Operations – TX',
          },
        ],
        [
          {
            label: 'Texas Real Estate Commission information about brokerage services',
            link: 'https://drive.google.com/file/d/1NMjX7L_BEHJWLQjUXnvf2Ivou4s8sTuA/view',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: 'Texas Real Estate Commission Consumer Protection Notice',
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: 'eXp Realty® is committed to adhering to the guidelines of The New York State Fair Housing Regulations. ',
          },
          {
            label: 'The Fair Housing Notice',
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: ' →',
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
        ],
        [
          {
            label: '*Standardized Operating Procedure for Purchasers of Real Estate Pursuant to Real Property Law 442-H. ',
          },
          {
            label: 'Learn More',
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
          {
            label: ' →',
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
        ],
        [
          {
            label: ' ',
          },
        ],
        [
          {
            label: 'eXp Realty of California, Inc. | CA DRE# 01878277 | Deborah Penny – Designated Broker',
          },
        ],
        [
          {
            label: 'eXp Realty of Southern California, Inc. | CA DRE# 02187306 | Gina Saad – Designated Broker',
          },
        ],
        [
          {
            label: 'eXp Realty of Greater Los Angeles, Inc. | CA DRE# 01828532 | Justin DeCesare – Designated Broker',
          },
        ],
        [
          {
            label: 'eXp Realty of Northern California, Inc. | CA DRE# 01951343 | Ryan Rosas – Designated Broker',
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.com/',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-in-service.png',
        alt: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
      },
    },
    showAccessibilityLink: false,
  };

  return footerConfig;
}